import { render, staticRenderFns } from "./AdvisorSurveyAnswers.vue?vue&type=template&id=39c290f2"
import script from "./AdvisorSurveyAnswers.vue?vue&type=script&lang=js"
export * from "./AdvisorSurveyAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports